__turbopack_context__.v({
  "accordionSlideOverwrite": "calculatorPage-module-scss-module__r1qrPq__accordionSlideOverwrite",
  "breadcrumb": "calculatorPage-module-scss-module__r1qrPq__breadcrumb",
  "calculatorContainer": "calculatorPage-module-scss-module__r1qrPq__calculatorContainer",
  "calculatorPage": "calculatorPage-module-scss-module__r1qrPq__calculatorPage",
  "descriptionContainer": "calculatorPage-module-scss-module__r1qrPq__descriptionContainer",
  "descriptionHeading": "calculatorPage-module-scss-module__r1qrPq__descriptionHeading",
  "fadeIn": "calculatorPage-module-scss-module__r1qrPq__fadeIn",
  "fadeOut": "calculatorPage-module-scss-module__r1qrPq__fadeOut",
  "faq": "calculatorPage-module-scss-module__r1qrPq__faq",
  "relatedCalcs": "calculatorPage-module-scss-module__r1qrPq__relatedCalcs",
  "relatedCalcsHeading": "calculatorPage-module-scss-module__r1qrPq__relatedCalcsHeading",
  "scaleIn": "calculatorPage-module-scss-module__r1qrPq__scaleIn",
  "scaleOut": "calculatorPage-module-scss-module__r1qrPq__scaleOut",
  "sectionHeading": "calculatorPage-module-scss-module__r1qrPq__sectionHeading",
  "sectionSubheading": "calculatorPage-module-scss-module__r1qrPq__sectionSubheading",
  "wrapper": "calculatorPage-module-scss-module__r1qrPq__wrapper",
  "zoomIn": "calculatorPage-module-scss-module__r1qrPq__zoomIn",
  "zoomOut": "calculatorPage-module-scss-module__r1qrPq__zoomOut",
});
